<template>
    <div style="padding:10px;">
        <div class="row">
            <div class="col-xs-12" style="text-align:right;">
                <div style="float:left;font-weight:bolder;">Msg</div>
                <textarea type="text" class="form-control" v-model="msg" />
                <span class="btn btn-default" @click="addMsg">Submit</span>
            </div>
        </div>

        <paged-loading :is-loading="loadingImg" @pagechange="onPageChange" :paging-info="paging">
            <div>

                <div class="col-xs-12" style="margin-top:10px;">
                    <div class="btn btn-default form-control" @click="reload">Refresh</div>
                </div>

                <div class="col-xs-12" v-for="item in items" style="margin-top:4px;cursor:pointer;border:1px solid #ddd;border-radius:10px;">
                    <div>
                        <span style="color:gray;font-size:smaller;">{{item.createDateUtc}}</span>
                        /<span class="btn btn-default" @click="enquire(item)">{{item.path}}</span>
                    </div>
                    <div style="font-size:smaller;text-align:right;color:#ddd;">{{item.createDateUtc}}</div>
                    <div style="white-space:pre-line;font-weight:bold;"> {{item.msg}} </div>

                    <div class="col-xs-12" v-for="rp in item.replies" style="margin-top:4px;cursor:pointer;border:1px solid #ddd;">

                        <div style="font-size:smaller;text-align:right;color:#ddd;">{{rp.createDateUtc}}</div>
                        <div style="white-space:pre-line;font-weight:bold;"> {{rp.msg}} </div>

                    </div>

                </div>
            </div>
        </paged-loading>
    </div>
</template>
<script>
    import pagedLoading from './base/PagedLoading.vue';
    import queryString from '../utl/queryString';

    export default {
        components: {
            pagedLoading: pagedLoading
        },
        props: ["toUserId", "pagePath", "pageQuery", "getOnCreated"],
        computed: {
            apiClient: function () {
                return this.mxnAgxApi.qaApiClient;
            },
        },
        data: function () {
            return {
                items: [],
                paging: { page: 1, pageSize: 1, count: 1 },
                loadingImg: false,
                msg: null
            };
        },
        methods: {
            enquire: function (item) {
                this.$emit('onenquire',item);
            },
            reload: function () {
                this.loadItems();
            },
            addMsg: function () {
                this.apiClient.addQAPrms({ msg: this.msg, toUserId: this.toUserId, path: this.pagePath, query: this.pageQuery })
                    .done((ret) => {
                        this.loadItems();
                    });
            },
            onPageChange: function (newPage) {
                this.paging.page = newPage;
                this.loadItems();
            },
            onSelect: function (file) {
                this.$emit('onselect', file);
            },
            loadItems: function () {
                var obj = { toUserId: this.toUserId, path: this.pagePath, query: this.pageQuery, ...this.paging };
                var that = this;
                this.loadingImg = true;
                this.apiClient.getQAPrms(queryString().getString(obj)).done(function (ret) {
                    that.loadingImg = false;
                    var filter = ret.filter;
                    that.paging = { page: filter.page, pageSize: filter.pageSize, count: filter.count };
                    that.items = ret.items;
                }).fail(function () {
                    that.loadingImg = false;
                });
            }
        },
        created: function () {
            if (this.getOnCreated !== false) {
                this.loadItems();
            }
            this.apiClient.onLoginApi.on(this.loadItems);
        },
        destroyed: function () {
            this.apiClient.onLoginApi.remove(this.loadItems);
        }
    }
</script>